module.exports = __webpack_public_path__ + "static/media/img_cws_code.ef35b6c3.jpg";